import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * AppLoadingState - the ONE loading indicator used everywhere a page or
 * section is waiting on data (Section 47's shared-component list). Using
 * this instead of an ad-hoc <Spin /> in every page keeps loading states
 * visually consistent and gives us one place to add skeleton loading later
 * (Section 54's performance guidance) without touching every page.
 */
export function AppLoadingState({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '48px 0' }}>
      <Spin size="large" />
      <span style={{ color: 'var(--triplink-text-muted, #5B645F)' }}>{label ?? t('state.loading')}</span>
    </div>
  );
}
